import { Component, OnInit } from '@angular/core';
import { ReferenceType } from 'src/app/shared/model/ReferenceType';
import { UploadDocumentParameters } from '../../models/UploadDocumentParameters';
import { UploadFilesSettings } from '../../models/UploadFilesSettings';
import { DocumentType } from 'src/app/shared/model/DocumentType';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-entity-docs',
  templateUrl: './entity-docs.component.html',
  styleUrls: ['./entity-docs.component.scss']
})
export class EntityDocsComponent implements OnInit {

  constructor(
    private activatedRoute: ActivatedRoute) { }

  uploadFilesSettings: UploadFilesSettings;
  entityReferenceType : ReferenceType = ReferenceType.Entity;
  entityId: number;
  ngOnInit(): void {

    this.entityId = this.activatedRoute.snapshot.params.entityId;

    const uploadDocumentParameters :  UploadDocumentParameters =  {
      documentTypeId: DocumentType.EntityDocument,
      referenceType: ReferenceType.Entity,
      referenceId: this.entityId.toString(),
      otherDocumentKindName : '',
      description: '',
      proofDocumentIds: []
    }

    this.uploadFilesSettings  = {
      uploadDocumentParameters : uploadDocumentParameters,
      fileRestrictions: null,
      showTopButtons: false,
      autoUpload : false,
      showDocumentDataDialog: true,
      documentDataDialogContent: null
    };    
  }

}



